export const FIELD_TYPES = {
    IMAGE: 'IMAGE',
    TEXT: 'TEXT',
    SHAPE: 'SHAPE',
    PRODUCT_DIMENSION: 'PRODUCT_DIMENSION',
    GROUP: 'GROUP',
    SMART_OBJECT: 'SMART_OBJECT',
    NEW_SMART_OBJECT: 'NEW_SMART_OBJECT',
    RECTANGLE: 'RECTANGLE',
    ELLIPSE: 'ELLIPSE'
}
